var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2566 3.20311C21.0387 3.17794 20.8181 3.21704 20.6221 3.31561L15.5 5.87498V10.375L20.6221 12.9344C20.7934 13.02 20.9837 13.0604 21.1751 13.0519C21.3664 13.0434 21.5523 12.9862 21.7154 12.8857C21.8784 12.7852 22.013 12.6447 22.1066 12.4777C22.2002 12.3106 22.2495 12.1224 22.25 11.9309V4.31911C22.2497 4.04375 22.1484 3.77807 21.9653 3.57239C21.7822 3.36672 21.5301 3.23532 21.2566 3.20311Z",
    fill: "#9F7943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 0.25C2.39937 0.25 0.875 1.77437 0.875 3.625V12.625C0.875 14.4756 2.39937 16 4.25 16H13.25C15.1006 16 16.625 14.4756 16.625 12.625V3.625C16.625 1.77437 15.1006 0.25 13.25 0.25H4.25Z",
    fill: "#9F7943"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.ded879168518bafc8ac6200f11fecd54.svg";
export { ForwardRef as ReactComponent };